
import * as ActionTypes from "./actionTypes";

export function clearResetPasswordFlag() {
    return { type: ActionTypes.RESET_PASSWORD_CLEAR, payload: null };
}


